interface VehiculoUso {
  label: string;
  value: string;
}

// Los usos granulares se conservan tal como los elige el usuario. El colapso a
// Particular/Comercial que esperan las aseguradoras se resuelve al enviar la
// cotización, con el helper de ~constants/usosVehiculo.
const getVehiculosUsos = (): VehiculoUso[] => {
  let result: VehiculoUso[] = [
    {
      label: "Uso particular",
      value: "Particular",
    },
    {
      label: "Comercial",
      value: "Comercial",
    },
    {
      label: "Transp. de mercaderias, herramientas y fletes",
      value: "MercaderiaHerramientasFletes",
    },
    {
      label: "Transporte de combustibles",
      value: "Combustibles",
    },
    {
      label: "Transporte de cargas peligrosas",
      value: "CargasPeligrosas",
    },
    {
      label: "Servicios especiales de pasajeros",
      value: "ServiciosEspeciales",
    },
    {
      label: "Taxi o remis",
      value: "TaxiRemis",
    },
    {
      label: "Transporte público",
      value: "TransportePublico",
    },
  ];

  return result;
};

export default getVehiculosUsos;
